import React from "react";

export default ({html, ...props}) => <div dangerouslySetInnerHTML={{__html: html}} {...props} />